import React from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';

import ChatIconButton from '$app-web/ui-kit/components/chat-icon-button';

import classes from './styles.module.scss';

const GoToBottomButton = (props) => {
    const { badgeValue, className, onClick } = props;

    return (
        <div className={clsx('relative', className)}>
            <ChatIconButton icon={['fas', 'arrow-down']} color="primary-dark" fill onClick={onClick} />
            {/* TODO: Define a Badge component and use that instead. */}
            {badgeValue !== 0 && <div className={classes.badge}>{badgeValue <= 99 ? badgeValue : '+9'}</div>}
        </div>
    );
};

GoToBottomButton.defaultProps = {
    badgeValue: 0,
    className: undefined,
};

GoToBottomButton.propTypes = {
    badgeValue: PropTypes.number,
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
};

export default GoToBottomButton;
